import React, { useState } from 'react';
import { Card, Button, Form } from "tabler-react";
import { useFetch } from '../../../lib/useFetch';
import postObject from '../../../lib/postObject';
import { useForm } from '../../../lib/useForm';
import Select from 'react-select';
import ImageUpload from '../../../components/imageUpload';

const StoreCreateModal = ({ closeMainModal, reload }) => {
  const [form, handleChange] = useForm({ name: '', url: '' });
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [image, setImage] = useState('');
  const [logo, setLogo] = useState('');
  const { data: categories, loading: categoriesLoading } = useFetch('categories');
  const [saveLoading, setSaveLoading] = useState(false);
  const [error, setError] = useState('');

  const validateForm = () => {
    if (!form.name) {
      setError('Please enter store name');
      return false;
    }
    if (!form.url) {
      setError('Please enter store URL');
      return false;
    }
    if (!selectedCategory) {
      setError('Please select a category');
      return false;
    }
    if (!image) {
      setError('Please select a store photo');
      return false;
    }
    if (!logo) {
      setError('Please select a store logo');
      return false;
    }
    return true;
  };

  const saveStore = async () => {
    setError('');
    if (!validateForm()) return;

    try {
      setSaveLoading(true);
      await postObject('stores', {
        ...form,
        image,
        logo,
        categoryId: selectedCategory.value,
      });
      if (typeof reload === 'function') {
        reload();
      }
      closeMainModal();
    } catch (err) {
      setError('Failed to create store. Please try again.');
    } finally {
      setSaveLoading(false);
    }
  };

  return (
    <Card>
      <Card.Header>
        <Card.Title>Create Store</Card.Title>
        <Card.Options>
          <Button
            size="sm"
            icon="x"
            onClick={closeMainModal}
          />
        </Card.Options>
      </Card.Header>
      <Card.Body>
        {error && <div className="alert alert-danger">{error}</div>}
        <Form onSubmit={(e) => { e.preventDefault(); saveStore(); }}>
          <Form.Input
            name="name"
            label="Name"
            placeholder="Enter store name"
            value={form.name}
            onChange={handleChange}
            required
          />

          <Form.Input
            name="url"
            label="URL"
            placeholder="Enter store URL"
            value={form.url}
            onChange={handleChange}
            required
          />

          <Form.Label>Category *</Form.Label>
          <Select
            value={selectedCategory}
            options={categories?.map(cat => ({
              label: cat.name,
              value: cat._id
            }))}
            placeholder="Select a category"
            isLoading={categoriesLoading}
            onChange={setSelectedCategory}
            isClearable
          />

          <ImageUpload
            label="Store Photo"
            required
            uploadText="Click here to upload store photo"
            alt="Store Photo Preview"
            onChange={(value) => setImage(value)}
          />

          <ImageUpload
            label="Store Logo"
            required
            uploadText="Click here to upload store logo"
            alt="Store Logo Preview"
            onChange={(value) => setLogo(value)}
          />
        </Form>
      </Card.Body>
      <Card.Footer>
        <div style={{ textAlign: 'right' }}>
          <Button
            color="primary"
            size="sm"
            className={`ml-2 ${saveLoading ? 'btn-loading' : ''}`}
            onClick={saveStore}
            disabled={saveLoading}
          >
            Save
          </Button>
          <Button
            color="secondary"
            size="sm"
            className="ml-2"
            onClick={closeMainModal}
            disabled={saveLoading}
          >
            Cancel
          </Button>
        </div>
      </Card.Footer>
    </Card>
  );
};

export default StoreCreateModal;
